class RecentlyViewed {
  constructor(maxItems = 5, expireDays = 7) {
    this.key = "rv_products";
    this.max = maxItems;
    this.expire = expireDays * 24 * 60 * 60 * 1000;
    this.isSeibiMode = new URLSearchParams(window.location.search).has("seibi");
  }

  init() {
    this.clean();
    this.addCurrentProduct();
    this.render();
  }

  get current() {
    const el = document.getElementById("CurrentProductData");
    if (!el || !el.textContent.trim()) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn("Invalid product data in #CurrentProductData:", e);
      return null;
    }
  }

  get list() {
    try {
      return JSON.parse(localStorage.getItem(this.key)) || [];
    } catch {
      return [];
    }
  }

  save(list) {
    localStorage.setItem(this.key, JSON.stringify(list));
  }

  addCurrentProduct() {
    const p = this.current;
    if (!p || !p.id || !p.url || typeof p.is_regular !== "boolean") return;
    const now = Date.now();
    let items = this.list.filter((item) => item.id !== p.id);
    items.unshift({ ...p, ts: now });

    // 正規品・整備品それぞれについて規定数を保持する。
    const regularItems = items.filter((item) => item.is_regular === true).slice(0, this.max);
    const seibiItems = items.filter((item) => item.is_regular === false).slice(0, this.max);
    items = [...regularItems, ...seibiItems].sort((a, b) => b.ts - a.ts);
    this.save(items);
  }

  clean() {
    const now = Date.now();
    const items = this.list.filter((item) => now - item.ts < this.expire);
    this.save(items);
  }

  render() {
    const wrapper = document.getElementById("recently-viewed-products");
    const container = document.querySelector(".rv-product-list");
    if (!container || !wrapper) return;

    const products = this.list
      .filter((p) => {
        if (!p.url || typeof p.is_regular !== "boolean") return false;
        return this.isSeibiMode ? p.is_regular === false : p.is_regular === true;
      })
      .slice(0, this.max);
    if (products.length === 0) {
      wrapper.hidden = true;
      return;
    }

    wrapper.hidden = false;
    container.innerHTML = products
      .map(
        (p) => `
      <a class="rv-item-link" href="${this.productUrl(p.url)}">
        <div class="rv-item-wrapper">
          <div class="rv-item-image-wrapper">
            <img src="${this.escapeAttribute(p.featured_image)}" alt="${this.escapeAttribute(p.title)}" />
          </div>
          <span class="rv-item-title">${this.escapeHTML(p.title)}</span>
          <span class="rv-item-price">${this.escapeHTML(p.price)}</span>
        </div>
      </a>
    `
      )
      .join("");
  }

  productUrl(path) {
    const url = new URL(path, window.location.origin);
    if (this.isSeibiMode) {
      url.searchParams.set("seibi", "");
    } else {
      url.searchParams.delete("seibi");
    }
    return `${url.pathname}${url.search}${url.hash}`;
  }

  escapeHTML(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  escapeAttribute(value) {
    return this.escapeHTML(value);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new RecentlyViewed().init();
});
